module.exports = __webpack_public_path__ + "img/ban.bfb8f870.svg";